import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "../../../../../adapter-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-file',
  props: {
  contentText: {
    type: Array,
    default: [],
  },
  messageContent: {
    type: Object,
    default: () => ({}),
  },
  displayType: {
    type: String,
    default: "bubble", // 两种展示形式: "bubble":气泡内文件消息展示 "file":搜索文件列表文件消息展示
  },
},
  setup(__props) {

const props = __props


const contentText = ref<Array<{ text: string; isHighlight: boolean }>>(props.contentText);
const typeIcon = computed(() => {
  const fileUrl = props?.messageContent?.url;
  const index = fileUrl?.lastIndexOf(".");
  const type = fileUrl?.substring(index + 1);
  return handleFileIconForShow(type);
});
const fileSize = computed(() => props?.messageContent?.size);
const handleFileIconForShow = (type: string) => {
  const urlBase = "https://web.sdk.qcloud.com/component/TUIKit/assets/file-";
  const fileTypes = [
    "image",
    "pdf",
    "text",
    "ppt",
    "presentation",
    "sheet",
    "zip",
    "word",
    "video",
    "unknown",
  ];
  let url = "";
  let iconType = "";
  fileTypes?.forEach((typeName: string) => {
    if (type?.includes(typeName)) {
      url = urlBase + typeName + ".svg";
      iconType = typeName;
    }
  });
  return {
    iconSrc: url ? url : urlBase + "unknown.svg",
    iconType: iconType ? iconType : "unknown",
  };
};

return { __sfc: true,props, contentText, typeIcon, fileSize, handleFileIconForShow }
}

})